import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyPageContent"] */ "/app/components/frontend/privacy-policy/privacy-policy-page-content.tsx");
